import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListRowItemBase } from '../list-row-item-base';
import { ItemsListRowItemDisplayValueComponent } from '../display-value/display-value.component';

@Component({
    selector: 'fi-date-time',
    templateUrl: './date-time.component.html',
    styleUrls: ['./date-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemDateTimeComponent extends ItemsListRowItemBase {
    GetDisplayValue(data) {
        return ItemsListRowItemDisplayValueComponent.GetDisplayValue(data || this.data, this.head);
    }
}
